import React from 'react';
import { getValue, getSymbol } from '../utils';
import useUnitSystem from '../useUnitSystem';
const Litres = ({ children, precision = 2 }) => {
    const unitSystem = useUnitSystem();
    const value = getValue(Number(children), 'litres', unitSystem, precision);
    const symbol = getSymbol('litres', unitSystem);
    return (React.createElement(React.Fragment, null,
        value,
        " ",
        symbol));
};
export default Litres;
//# sourceMappingURL=Litres.js.map